import React, { useEffect, useState } from 'react';
import { filter } from 'ramda';
import styled from 'styled-components';
import Multilingual from '~~utils/Multilingual';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import { GameSectionDiv, StyledForm } from '../styled';

const StyledDiv = styled.div`
  width: 100%;
  .box {
    .input-field {
      width: 100%;
    }
  }

  .link-section {
    width: 100%;
    border-bottom: 1px solid #eee;
    padding: 0 0 0.5rem 0;
    margin: 0 0 1rem 0;
  }
`;

const getDeepCopyRelatedLinks = (relatedLinks) => {
  return relatedLinks.map((l) => ({ title: l.title, link: l.link }));
};

const GameRelatedLinksSection = ({ relatedLinks, onChange, apiInProgress }) => {
  const [currentRelatedLinks, setCurrentRelatedLinks] = useState(getDeepCopyRelatedLinks(relatedLinks));

  useEffect(() => {
    setCurrentRelatedLinks(getDeepCopyRelatedLinks(relatedLinks));
  }, [relatedLinks]);

  useEffect(() => {
    const removeEmptyCurrentRelatedLinks = filter((l) => l.title || l.link, currentRelatedLinks);
    if (relatedLinks.length !== removeEmptyCurrentRelatedLinks.length) {
      onChange(removeEmptyCurrentRelatedLinks);
      return;
    }

    let changed = false;
    for (let index = 0; index < removeEmptyCurrentRelatedLinks.length; index++) {
      const originRelatedLink = relatedLinks[index];
      const currentRelatedLink = removeEmptyCurrentRelatedLinks[index];
      if (originRelatedLink.title === currentRelatedLink.title && originRelatedLink.link === currentRelatedLink.link) {
        continue;
      }

      changed = true;
      break;
    }

    if (!changed) {
      onChange(null);
      return;
    }

    onChange(removeEmptyCurrentRelatedLinks);
  }, [currentRelatedLinks, onChange, relatedLinks]);

  const handleInputOnChange = (index) => (e) => {
    const name = e.target.name;
    const value = e.target.value;
    for (let i = 0; i <= index; i++) {
      if (currentRelatedLinks[i]) {
        continue;
      }

      currentRelatedLinks[i] = {
        title: '',
        link: '',
      };
    }

    currentRelatedLinks[index][name] = value;
    setCurrentRelatedLinks([...currentRelatedLinks]);
  };

  const cleanUpLink = (index) => () => {
    if (!currentRelatedLinks[index]) {
      return;
    }

    currentRelatedLinks[index] = {
      title: '',
      link: '',
    };
    setCurrentRelatedLinks([...currentRelatedLinks]);
  };

  return (
    <GameSectionDiv>
      <h3 className="section--title">{Multilingual(`GAME.RELATED_LINKS.WORDING`)}</h3>
      <div className="section--description">{Multilingual(`TOURNAMENT.RELATED_LINKS_DESCRIPTION`)}</div>
      <StyledForm onSubmit={(e) => e.preventDefault()}>
        <StyledDiv>
          <div className="box">
            {new Array(10).fill('').map((_, index) => (
              <div key={index} className="link-section">
                {/* 標題 */}
                <div>
                  {`${index + 1}. ${Multilingual(`GAME.RELATED_LINKS.TITLE`)}`}
                  {currentRelatedLinks[index] && (currentRelatedLinks[index].title || currentRelatedLinks[index].link) && (
                    <Button width="unset" color="transparentWithBorder" mini onClick={cleanUpLink(index)}>
                      {Multilingual(`FORM.CLEAN_UP`)}
                    </Button>
                  )}
                </div>
                <Input
                  width="100%"
                  name="title"
                  value={!currentRelatedLinks[index] ? '' : currentRelatedLinks[index].title}
                  onChange={handleInputOnChange(index)}
                  disabled={apiInProgress}
                />
                {/* 連結 */}
                <label>{Multilingual(`GAME.RELATED_LINKS.LINK`)}</label>
                <Input
                  width="100%"
                  name="link"
                  value={!currentRelatedLinks[index] ? '' : currentRelatedLinks[index].link}
                  onChange={handleInputOnChange(index)}
                  disabled={apiInProgress}
                  placeholder="https://"
                />
              </div>
            ))}
          </div>
        </StyledDiv>
      </StyledForm>
    </GameSectionDiv>
  );
};

export default GameRelatedLinksSection;
